[
  {
    "id": "TB-E6P-001",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Wat betekent het spreekwoord: 'De kat uit de boom kijken'?",
    "options": ["Even afwachten wat er gebeurt", "Bang zijn voor katten", "In een boom klimmen", "Ruzie maken"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "taalbegrip",
    "subSkill": "spreekwoorden",
    "familyId": "TB-SPREEK-KAT",
    "explanation": "'De kat uit de boom kijken' betekent dat je even afwacht wat er gebeurt voordat je iets doet.",
    "distractorExplanations": {
      "1": "Dit is te letterlijk genomen.",
      "2": "Dit is te letterlijk genomen.",
      "3": "Dit heeft niets met het spreekwoord te maken."
    }
  },
  {
    "id": "TB-E6P-002",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Welk woord is een synoniem voor 'vlug'?",
    "options": ["snel", "langzaam", "groot", "mooi"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-SYN-VLUG",
    "explanation": "Vlug en snel betekenen hetzelfde. Het zijn synoniemen.",
    "distractorExplanations": {
      "1": "Langzaam is het tegenovergestelde (antoniem).",
      "2": "Groot heeft een andere betekenis.",
      "3": "Mooi heeft een andere betekenis."
    }
  },
  {
    "id": "TB-E6P-003",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Lees de tekst:\n\n\"De Sahara is niet alleen zand. Er zijn ook rotsachtige gebieden, oases met palmbomen en zelfs bergen. De hoogste berg in de Sahara is meer dan 3.000 meter hoog!\"\n\nWat wil de schrijver duidelijk maken?",
    "options": [
      "Dat de Sahara veel gevarieerder is dan mensen denken",
      "Dat de Sahara alleen uit zand bestaat",
      "Dat bergen heel hoog zijn",
      "Dat palmbomen in de woestijn groeien"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "doel_schrijver",
    "familyId": "TB-SAHARA-DOEL",
    "explanation": "De eerste zin ('niet alleen zand') en de opsomming van andere landschappen laten zien dat de Sahara gevarieerder is dan gedacht.",
    "distractorExplanations": {
      "1": "De tekst zegt juist het tegenovergestelde.",
      "2": "Bergen zijn een detail, niet het hoofdpunt.",
      "3": "Palmbomen zijn een detail."
    }
  },
  {
    "id": "TB-E6P-004",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Wat betekent het spreekwoord: 'Met de deur in huis vallen'?",
    "options": ["Meteen zeggen waar het om gaat", "Een deur kapot maken", "Binnenvallen bij iemand", "Hard werken"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "spreekwoorden",
    "familyId": "TB-SPREEK-DEUR",
    "explanation": "'Met de deur in huis vallen' betekent meteen zeggen waar het om gaat, zonder inleiding.",
    "distractorExplanations": {
      "1": "Dit is te letterlijk genomen.",
      "2": "Dit is te letterlijk genomen.",
      "3": "Dit heeft niets met het spreekwoord te maken."
    }
  },
  {
    "id": "TB-E6P-005",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Lees de tekst:\n\n\"Bliksem is eigenlijk elektriciteit. Tijdens een onweersbui botsen ijskristallen in de wolken tegen elkaar. Daardoor ontstaat er een enorme elektrische lading. Als die lading groot genoeg is, springt er een vonk over: bliksem!\"\n\nIn welke volgorde ontstaat bliksem?\n1. Er springt een vonk over\n2. IJskristallen botsen tegen elkaar\n3. Er ontstaat een elektrische lading",
    "options": ["2 → 3 → 1", "1 → 2 → 3", "3 → 1 → 2", "2 → 1 → 3"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstbegrip",
    "subSkill": "volgorde",
    "familyId": "TB-BLIKSEM-VOLGORDE",
    "explanation": "Eerst botsen ijskristallen (2), daardoor ontstaat lading (3), en als die groot genoeg is springt er een vonk over (1).",
    "distractorExplanations": {
      "1": "De vonk komt als laatste, niet als eerste.",
      "2": "De lading moet eerst opgebouwd worden.",
      "3": "De vonk komt na de lading, niet ervoor."
    }
  },
  {
    "id": "TB-E6P-006",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Welk woord is een synoniem voor 'blij'?",
    "options": ["vrolijk", "verdrietig", "boos", "moe"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-SYN-BLIJ",
    "explanation": "Blij en vrolijk betekenen ongeveer hetzelfde.",
    "distractorExplanations": {
      "1": "Verdrietig is het tegenovergestelde.",
      "2": "Boos is een andere emotie.",
      "3": "Moe is een ander gevoel."
    }
  },
  {
    "id": "TB-E6P-007",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Lees de tekst:\n\n\"Wetenschappers hebben ontdekt dat planten sneller groeien als je tegen ze praat. Of eigenlijk: als ze trillingen voelen. Muziek werkt ook. Het maakt niet uit wat je zegt — de trillingen helpen de plant.\"\n\nWat helpt planten om te groeien?",
    "options": [
      "Trillingen (van praten of muziek)",
      "De woorden die je zegt",
      "Alleen klassieke muziek",
      "Stilte"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "tekstanalyse",
    "subSkill": "conclusie_trekken",
    "familyId": "TB-PLANTEN-PRATEN",
    "explanation": "De tekst zegt: 'Het maakt niet uit wat je zegt — de trillingen helpen de plant.' Het gaat om trillingen, niet om woorden.",
    "distractorExplanations": {
      "1": "De tekst zegt expliciet dat het niet uitmaakt wat je zegt.",
      "2": "De tekst noemt muziek in het algemeen, niet alleen klassiek.",
      "3": "Stilte is het tegenovergestelde van wat helpt."
    }
  },
  {
    "id": "TB-E6P-008",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Wat betekent het spreekwoord: 'Een appeltje voor de dorst'?",
    "options": ["Geld opzij leggen voor later", "Een appel eten als je dorst hebt", "Heel zuinig leven", "Iets lekkers bewaren"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "spreekwoorden",
    "familyId": "TB-SPREEK-APPEL",
    "explanation": "'Een appeltje voor de dorst' betekent geld of iets waardevols opzij leggen voor moeilijke tijden.",
    "distractorExplanations": {
      "1": "Dit is te letterlijk genomen.",
      "2": "Zuinig leven is iets anders dan sparen voor later.",
      "3": "Het gaat niet over eten bewaren."
    }
  },
  {
    "id": "TB-E6P-009",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Welk woord is een synoniem voor 'moeilijk'?",
    "options": ["lastig", "makkelijk", "leuk", "saai"],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "woordenschat",
    "subSkill": "woordbetekenis",
    "familyId": "TB-SYN-MOEILIJK",
    "explanation": "Lastig en moeilijk betekenen ongeveer hetzelfde.",
    "distractorExplanations": {
      "1": "Makkelijk is het tegenovergestelde.",
      "2": "Leuk heeft een andere betekenis.",
      "3": "Saai heeft een andere betekenis."
    }
  },
  {
    "id": "TB-E6P-010",
    "module": "Taalbegrip",
    "difficulty": 106,
    "question": "Lees de tekst:\n\n\"De koala slaapt 22 uur per dag. De reden? Eucalyptusbladeren, zijn enige voedsel, bevatten heel weinig energie. Door zo veel te slapen, spaart de koala energie.\"\n\nWat is de oorzaak dat de koala zoveel slaapt?",
    "options": [
      "Zijn voedsel bevat heel weinig energie",
      "Hij is ziek",
      "Hij vindt slapen leuk",
      "Het is altijd nacht in Australië"
    ],
    "correctAnswer": 0,
    "questionType": "multiple_choice",
    "skill": "verbanden",
    "subSkill": "oorzaak_gevolg",
    "familyId": "TB-KOALA-SLAAP",
    "explanation": "De tekst legt het oorzaak-gevolg uit: weinig energie in voedsel (oorzaak) → veel slapen om energie te sparen (gevolg).",
    "distractorExplanations": {
      "1": "Ziekte wordt niet genoemd.",
      "2": "Het gaat niet om voorkeur maar om noodzaak.",
      "3": "In Australië is het niet altijd nacht."
    }
  }
]